import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { Label } from '../page-components/Label';
import { Input } from '../page-components/Input';
import { ErrorContainer } from '../page-components/ErrorContainer';
import { WhisperComponent } from '../page-components/WhisperComponent';
import { InputType } from '../../form/form-input-constants';

interface Props {
	formik: any;
	fieldLabel: string;
	fieldName: string;
	tooltipText: string;
}

export const WidgetLink = (props: Props): React.ReactElement => {
	const { formik, fieldLabel, fieldName, tooltipText } = props;
	const { t } = useTranslation();

	return (
		<div className="col-12 input-container mb-5">
			<Label additionalClass="form-label col-12" fieldLabel={fieldLabel}>
				<>
					<WhisperComponent
						whisperText={tooltipText}
						mainText={
							<FontAwesomeIcon icon={faQuestionCircle} className="cursor-pointer" width={12}/>
						}
						isTooltip
					/>

					<Input
						formik={formik}
						inputType={InputType.Text}
						placeholder={t('COLOR_MODULE.LINK_PLACEHOLDER')}
						fieldName={fieldName}
						additionalClass="mb-3"
					/>
				</>
			</Label>
			<ErrorContainer formik={formik} fieldName={fieldName} additionClass="error-container position-absolute"/>
		</div>
	);
};
